export default "__VITE_ASSET__DLL$HiwU__"